import styled from 'styled-components';

import AntdIcon from '@ant-design/icons';

interface StyledIconProps {
  $disabled?: boolean;
}

export const Icon = styled(AntdIcon)<StyledIconProps>`
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ $disabled }) => ($disabled ? 0.4 : 1)};
  pointer-events: ${({ $disabled }) => ($disabled ? 'none' : 'auto')};
  transition: opacity 0.2s ease;
`;

export const Container = styled.div(({ theme }) => ({
  alignItems: 'flex-start',
  display: 'flex',
  flexDirection: 'row',
  gap: '24px',
  justifyContent: 'end',
  marginBlock: '10rem',

  [theme.breakpoint.media.max.sm]: {
    paddingInline: '24rem',
  },
}));
